import { defineStore } from 'pinia';
import stateCitiesAPI from '@/api/state_cities';

export const useStatesCitiesStore = defineStore('statesCities', {
    state: () => ({
        states: [] as any[],
        cities: [] as any[],
    }),
    actions: {
        async searchStates(filters: any) {
            try {
                const response = await stateCitiesAPI.searchStates(filters);
                this.states = response;
            } catch (error) {
                console.error('Error fetching states:', error);
            }
        },
        async searchCitiesByState(filters: any) {
            try {
                const response = await stateCitiesAPI.searchCitiesByState(filters);
                this.cities = response;
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        }
    }
});